import { render, staticRenderFns } from "./interact-publish.vue?vue&type=template&id=1b02f532&scoped=true&"
import script from "./interact-publish.vue?vue&type=script&lang=js&"
export * from "./interact-publish.vue?vue&type=script&lang=js&"
import style0 from "./interact-publish.vue?vue&type=style&index=0&id=1b02f532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02f532",
  null
  
)

export default component.exports